import { dataLinkAltSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconLinkAltSolid = /*#__PURE__*/createIcon(dataLinkAltSolid)
export default IconLinkAltSolid
